import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { sanityClient } from "@/js/sanity/client";
import { urlForImage } from "@/js/sanity/image";
import BackgroundVideo from "@/components/default/BackgroundVideo.vue";
import PostSections from "@/components/blog/PostSections.vue";
export default {
  name: "cellarJournalDetail",
  components: {
    BackgroundVideo: BackgroundVideo,
    PostSections: PostSections
  },
  props: {
    slug: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      post: null
    };
  },
  methods: {
    urlForImage: urlForImage
  },
  created: function created() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var query;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            query = "*[_type == \"post\" && slug.current == \"".concat(_this.$route.params.slug, "\"][0]{\n        title,\n        description,\n        mainImage,\n        sections[]{\n          ...,\n          _type == \"postSection2\" => {\n            ...,\n            \"video\": video.asset->\n          },\n          _type == \"postSection4\" => {\n            ...,\n            media1{\n              ...,\n              mediaType == \"video\" => {\n                \"video\": video.asset->\n              },\n            },\n            media2{\n              ...,\n              mediaType == \"video\" => {\n                \"video\": video.asset->\n              },\n            },\n          },\n        }\n      }");
            _context.next = 4;
            return sanityClient.fetch(query);
          case 4:
            _this.post = _context.sent;
            _context.next = 10;
            break;
          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            console.error("Error fetching posts:", _context.t0);
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 7]]);
    }))();
  }
};